var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1715_523",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1715_523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3327 17.0002V14.1668H22.666V17.0002H11.3327ZM11.3327 11.3335V8.50016H22.666V11.3335H11.3327ZM8.49935 19.8335H19.1243C19.8091 19.8335 20.4466 19.9811 21.0369 20.2762C21.6271 20.5713 22.123 20.9904 22.5244 21.5335L25.4994 25.4293V5.66683H8.49935V19.8335ZM8.49935 28.3335H24.1535L20.2931 23.2689C20.1514 23.08 19.9803 22.9325 19.7796 22.8262C19.5789 22.72 19.3605 22.6668 19.1243 22.6668H8.49935V28.3335ZM25.4994 31.1668H8.49935C7.72018 31.1668 7.05317 30.8894 6.49831 30.3345C5.94345 29.7797 5.66602 29.1127 5.66602 28.3335V5.66683C5.66602 4.88766 5.94345 4.22065 6.49831 3.66579C7.05317 3.11093 7.72018 2.8335 8.49935 2.8335H25.4994C26.2785 2.8335 26.9455 3.11093 27.5004 3.66579C28.0553 4.22065 28.3327 4.88766 28.3327 5.66683V28.3335C28.3327 29.1127 28.0553 29.7797 27.5004 30.3345C26.9455 30.8894 26.2785 31.1668 25.4994 31.1668Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/lab.aaaf6135332dd52e85a2634b752bc0d8.svg";
export { ForwardRef as ReactComponent };